export default {
    folder: process.env.NODE_ENV === 'production'
        ? '/help/feedbacktest'
        : ''
}